export function addFiltersToUrl(filters = [], url = "") {
    let filterItems = ""

    if (filters && filters.length > 0) {
        filters.map((item, index) => {
            if (index === 0) {
                filterItems = item
            } else
                filterItems = filterItems + `&${item}`
        })
    }
    return `${url}?${filterItems}`
}